import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=864577f6&scoped=true&"
import script from "./EditBranch.vue?vue&type=script&lang=js&"
export * from "./EditBranch.vue?vue&type=script&lang=js&"
import style0 from "./EditBranch.vue?vue&type=style&index=0&id=864577f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864577f6",
  null
  
)

export default component.exports